'use client';

import { cn } from '@/lib/utils';
import {
  InformationCircleIcon,
  ExclamationTriangleIcon,
  XCircleIcon,
  CheckCircleIcon,
} from '@heroicons/react/24/outline';

const variants = {
  info: {
    container: 'bg-blue-50',
    icon: 'text-blue-500',
    text: 'text-blue-700',
  },
  warning: {
    container: 'bg-amber-50',
    icon: 'text-amber-500',
    text: 'text-amber-700',
  },
  error: {
    container: 'bg-red-50',
    icon: 'text-red-500',
    text: 'text-red-700',
  },
  success: {
    container: 'bg-green-50',
    icon: 'text-green-500',
    text: 'text-green-700',
  },
};

const icons = {
  info: InformationCircleIcon,
  warning: ExclamationTriangleIcon,
  error: XCircleIcon,
  success: CheckCircleIcon,
};

export default function Alert({
  children,
  variant = 'info',
  className,
}) {
  const Icon = icons[variant];
  const styles = variants[variant];

  return (
    <div className={cn(
      'flex items-start gap-3 p-4 rounded-xl',
      styles.container,
      className
    )}>
      <Icon className={cn('w-5 h-5 flex-shrink-0', styles.icon)} />
      <p className={cn('text-sm', styles.text)}>
        {children}
      </p>
    </div>
  );
}
